module.exports = __webpack_public_path__ + "static/media/ic_laser.53e2198a.svg";